/* eslint-disable */
import source from './esc-pos-encoder.umd.js?raw'

;(new Function(source))()

export default window.EscPosEncoder
